import { useState } from "react";
import classNames from "classnames";

import styles from "./image.module.css"

export const Image = ({ src, className, alt="", objectFit = "contain", width = "100%", height = "100%", radius, ...props }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    return (
        <div 
            style={{ 
                width, 
                height,
                overflow: "hidden",
                borderRadius: radius,
            }} 
            className={classNames(
                className, 
                {[styles.loading]: error || loading}
            )}
        >
            <img
                src={src}
                alt={alt}
                style={{ 
                    width: "100%", 
                    height: "100%", 
                    objectFit, 
                    display: loading ? "none" : "block" 
                }}
                onLoad={() => setLoading(false)}
                onError={() => setError(true)}
                {...props}
            />
        </div>
    );
}